<template>
<div class="large-container">
	<Form :label-width="110">
		<Row v-if="wangdainShow">
			<Col span="24">
				<b>置换保</b>&nbsp;&nbsp;&nbsp;<Button type="info" @click="showWangdian()">绑定网点</Button>
			</Col>
		</Row>
		<Row :gutter="10" class="mt20">
			<Col span="8">
				<FormItem label="置换单编号">
					<Input v-model="params.claimsNo" :maxlength="50" clearable @on-enter="search" placeholder="请输入置换单编号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="产品型号">
					<Input v-model="params.machineModel" :maxlength="50" clearable @on-enter="search" placeholder="请输入产品型号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="网点信息">
					<Input v-model="params.companyInfo" :maxlength="50" clearable @on-enter="search" placeholder="请输入网点信息"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="工贸">
					<Input v-model="params.trade" :maxlength="50" clearable @on-enter="search" placeholder="请输入工贸"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="工单编号">
					<Input v-model="params.workOrderNo" :maxlength="50" clearable @on-enter="search" placeholder="请输入工单编号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="延保卡号">
					<Input v-model="params.extendWarrantyCardNo" :maxlength="50" clearable @on-enter="search" placeholder="请输入延保卡号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="产品序列号">
					<Input v-model="params.machineCode" :maxlength="50" clearable @on-enter="search" placeholder="请输入产品序列号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="审核状态">
					<Select v-model="params.auditStatus" placeholder="请选择审核状态" clearable>
						<Option value="WAITING">待审核</Option>
						<Option value="PASS">审核通过</Option>
						<Option value="REJECT">审核驳回</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="登记时间">
					<daterange @on-change="val => { setDateRange(val, 'registerTime') }" is-fulltime placeholder="请选择登记时间" placement="bottom-end"></daterange>
				</FormItem>
			</Col>
			<Col span="24" class="right mb24">
				<Button type="info" @click="search">搜索</Button>
			</Col>
		</Row>
	</Form>
	<i-table :columns="columns" url="/zhb/claims/list.json" 
		:params="params" ref="table" 
		:count="10">
		<template slot-scope="{ row }" slot="authPhotos">
			<a v-if="row.authPhotos" @click="openImg(row.authPhotos)">查看</a>
		</template>
		<template slot-scope="{ row }" slot="buyVoucher">
			<a v-if="row.buyVoucher" @click="openImg(row.buyVoucher)">查看</a>
		</template>
		<template slot-scope="{ row }" slot="action">
			<a :href="row.repairBillUrl" v-if="row.auditStatus&&row.repairBillUrl" target="_blank">查看维修单</a>
			<a v-if="row.auditStatus=='REJECT'||!(row.auditStatus)" @click="showRepairOrder(row)">上传维修单</a>
		</template>
	</i-table>
	<Modal v-model="wangdian.show" title="新增网点" :mask-closable="false" @on-visible-change="handleReset('wangdianForm')" >
		<Form :label-width="110" :model="wangdian.form" ref="wangdianForm">
			<Form-item label="HR码" :rules="{required: true,  message: '请输入HR码', trigger: 'blur'}" prop="hrCode">
				<Input v-model="wangdian.form.hrCode" :maxlength="100" placeholder="请输入HR码" clearable />
			</Form-item>
			<Form-item label="网点地址" :rules="{required: true,  message: '请输入网点地址', trigger: 'blur'}" prop="companyAddress">
				<Input v-model="wangdian.form.companyAddress" :maxlength="100" placeholder="请输入网点地址" clearable />
			</Form-item>
			<Form-item label="网点电话" :rules="{required: true,  message: '请输入网点电话', trigger: 'blur',pattern:rules.telOrPhone}" prop="companyPhone">
				<Input v-model="wangdian.form.companyPhone" :maxlength="100" placeholder="请输入网点电话" clearable />
			</Form-item>
		</Form>
		<div slot="footer">
			<Button @click="wangdian.show = false" type="default">取消</Button>
			<Button @click="bindWangdian()" type="primary">确定</Button>
		</div>
	</Modal>
	<Modal v-model="repairOrder.show" title="上传电子维修单" :mask-closable="false" @on-visible-change="handleReset('repairOrderForm')" >
		<Form :label-width="100" :model="repairOrder.form" ref="repairOrderForm" :rules="ruleValidate" >
			<Form-item label="顾客姓名" prop="customerName">
				<Input v-model="repairOrder.form.customerName" :maxlength="100" placeholder="请输入顾客姓名" clearable />
			</Form-item>
			<Form-item label="联系电话" prop="customerPhone">
				<Input v-model="repairOrder.form.customerPhone" :maxlength="100" placeholder="请输入顾客电话" clearable />
			</Form-item>
			<Form-item label="通讯地址" prop="customerAddress">
				<Input v-model="repairOrder.form.customerAddress" type="textarea" :maxlength="100" placeholder="请填写详细地址，例如：XXX省XXX市XXX区XXX路XXXX小区XXX号楼XXXX" clearable />
			</Form-item>
			<Form-item label="上传维修单" required>
				<p>请先录入上述内容再进行<a @click="downTemplate">下载模板</a>，并在盖章完成后再进行上传，支持格式：pdf、png、jpg、jpeg</p>
				<UploadFileImg @on-success="val=>uploadSuccess(val,'repairBillUrl')" type="select" btn-text="选择文件" :accept="['image','PDF']" /> 
				<a @click="openOriginFile(repairOrder.form.repairBillUrl)" v-show="repairOrder.form.repairBillUrl" class="ml15">查看</a>
			</Form-item>
		</Form>
		<div slot="footer">
			<Button @click="repairOrder.show = false" type="default">取消</Button>
			<Button @click="confirm" :disabled="!repairOrder.form.repairBillUrl" type="primary">提交</Button>
		</div>
	</Modal>
	<div class="demo-image__preview" v-show="false">
		<el-image
		ref="previewImg"
		:preview-src-list="srcList">
		</el-image>
	</div>
</div>
</template>
<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'
import UploadFileImg from '@/components/common/UploadFileImg'
import { mapState } from 'vuex'
export default {
	components:{daterange,ITable,UploadFileImg},
	data () {
		return {
			params:{},
			wangdian:{
				show:false,
				form:{}
			},
			repairOrder:{
				show:false,
				form:{}
			},
			columns:[
				{title: '置换单号',key: 'claimsNo', fixed:'left',width:this.$columnW.XL},
				{title: '工单编号',key: 'workOrderNo',width:this.$columnW.XL,ellipsis: true,tooltip: true},
				{title: '所属工贸',key: 'trade',width:this.$columnW.L},
				{title: '网点代码',key: 'hrCode',width:this.$columnW.L},
				{title: '网点名称',key: 'hrName',width:this.$columnW.L},
				{title: '商品名称',key: 'machineCategory',width:this.$columnW.L,ellipsis: true,tooltip: true},
				{title: '产品型号',key: 'machineModel',width:this.$columnW.XL,ellipsis: true,tooltip: true},
				{title: '服务方式',key: 'serviceType',width:this.$columnW.L},
				{title: '服务措施描述',key: 'serviceDesc',width:this.$columnW.XL,ellipsis: true,tooltip: true},
				{title: '部件',key: 'changeParts',width:this.$columnW.L},
				{title: '故障原因描述',key: 'faultDesc',width:this.$columnW.XL,ellipsis: true,tooltip: true},
				{title: '鉴定服务费',key: 'laborCost',width:this.$columnW.L,align:"right"},
				{title: '鉴定上门费',key: 'transportCost',width:this.$columnW.L,align:"right"},
				{title: '用户姓名',key: 'customerName',width:this.$columnW.M},
				{title: '产品序列号（机编）',key: 'machineCode',width:this.$columnW.XL,ellipsis: true,tooltip: true},
				{title: '新机型号',key: 'newMachineModel',width:this.$columnW.M,ellipsis: true,tooltip: true},
				{title: '新机品牌',key: 'newMachineBrand',width:this.$columnW.M,ellipsis: true,tooltip: true},
				{title: '新机零售价',key: 'newMachineRetailPrice',width:this.$columnW.M,align:"right"},
				{title: '新机结算价',key: 'newMachineSettlementPrice',width:this.$columnW.M,align:"right"},
				{title: '延保卡号',key: 'extendWarrantyCardNo',width:this.$columnW.L},
				{title: '保险公司',key: 'insuranceCompany',width:this.$columnW.XL},
				{title: '鉴定工单登记时间',key: 'registerTime',width:this.$columnW.L},
				{title: '录入时间',key: 'createTime',width:this.$columnW.L},
				{title: '鉴定照片',slot:'authPhotos',key: 'authPhotos',width:this.$columnW.L},
				{title: '购机凭证',slot:'buyVoucher',key: 'buyVoucher',width:this.$columnW.L},
				{title: '备注',key: 'remark',minWidth:this.$columnW.L,ellipsis: true,tooltip: true},
				{title: '审核时间',key: 'auditTime',width:this.$columnW.L},
				{title: '审核状态',key: 'auditStatusDesc',width:this.$columnW.M},
				{title: '操作',slot: 'action',width:this.$columnW.M,fixed:'right',align:"right"},
			],
			editForm:{},
			editShow:false,
			selectedList:[],
			modalTitle:'',
			ruleValidate: {
				customerName: [
					{ required: true, message: '顾客姓名不能为空', trigger: 'blur' }
				],
				customerPhone:[
					{required: true,  message: '联系电话不能为空', trigger: 'blur'},
					{required: true,  message: '联系电话格式不正确', trigger: 'blur',pattern:this.rules.telOrPhone}
				],
				customerAddress:[{required: true,  message: '通讯地址不能为空', trigger: 'blur'}]
            },
			srcList:[],
			wangdainShow:null
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		})
	},
	watch:{
		userInfo(){
			this.checkLogin()
		},
	},
	created () {
		this.checkLogin();
		this.getWangdian();
	},
	methods: {
		getWangdian(){
			this.$axios.get('/zhb/company/bind/find').then(res=>{
				let data = res&&res.length>0?false:true;
				this.wangdainShow = data;
			})
		},
		openImg(row){
			this.$nextTick(()=>{
				this.srcList = row.split(',')
			})
			this.$refs.previewImg.showViewer = true;
		},
		setDateRange (val, key) {
			this.params[key + 'Start'] = val[0];
			this.params[key + 'End'] = val[1];
		},
		btKeyDown(e) {
			e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,"");
		},
		//限制输入特殊字符
		btKeyUp(e) {
			e.target.value = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,"");
		},
		showWangdian () {
			this.wangdian.form = {}
			this.wangdian.show = true
		},
		showRepairOrder (row) {
			this.repairOrder.form = {}
			this.repairOrder.form.id = row.id;
			this.repairOrder.show = true
		},
		async bindWangdian () {
			let vaild = await this.$refs.wangdianForm.validate()
			if (vaild) {
				await this.$axios.post('/yanbao/agreement/bindCompanyUser.json',{
					...this.wangdian.form,
					productCode:'ZHIHUANBAO'
				})
				this.$refs.wangdianForm.resetFields()
				this.wangdian.form = {}
				this.search()
				this.getWangdian()
				this.wangdian.show=false;
				this.toast('操作成功')
			}
		},
		downTemplate () {
			this.$refs.repairOrderForm.validate((valid) => {
				if (valid) {
					this.$axios.get("/zhb/claims/repair/download.all",{
						id:this.repairOrder.form.id,
						customerName:this.repairOrder.form.customerName,
						customerPhone:this.repairOrder.form.customerPhone,
						customerAddress:this.repairOrder.form.customerAddress
					}).then(res=>{
						if(res.code==10000000){
							window.open(res.data)
						}
					})
				}
			})
		},
		confirm () {
			this.$refs.repairOrderForm.validate((valid) => {
				if (valid) {
					this.$axios.post('/zhb/claims/repair/upload.json',this.repairOrder.form).then(res=>{
						this.$refs.repairOrderForm.resetFields()
						this.repairOrder.form = {}
						this.search()
						this.repairOrder.show=false;
						this.toast('操作成功')
					});
				}
			})
		},
		search () {
			this.$refs.table.getList();
		},
		// 打开上传结算单
		openUpload(row){
			this.editForm = {}
			this.editForm.id=row.id
			this.editShow=true;
		},
		// 上传回调方法
		uploadSuccess(val,key){
			this.$set(this.repairOrder.form,key,val.url)
			this.$refs.repairOrderForm.validateField(key);
		},
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		handleReset (name) {
			this.$refs[name].resetFields()
		}
	}
}
</script>
<style lang="less" scoped>
	/deep/ .ivu-cascader{
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/zhihuanbao/Index.vue